/**
 * Priority as temperature. `heat` is 0 (routine) → 1 (breaching).
 * Returns the thermal stop used on a ticket's left edge, spine and the Pulse.
 */
export type ThermalStop = {
  varName: string;
  label: string;
};

export function thermal(heat: number): ThermalStop {
  if (heat >= 0.85) return { varName: '--temp-ember', label: 'Breaching' };
  if (heat >= 0.65) return { varName: '--temp-hot', label: 'Hot' };
  if (heat >= 0.4) return { varName: '--temp-warm', label: 'Warming' };
  return { varName: '--temp-cool', label: 'Routine' };
}

/** CSS color string for a heat level. */
export function thermalColor(heat: number): string {
  return `hsl(var(${thermal(heat).varName}))`;
}

/** A soft vertical gradient for a ticket's warmth edge. */
export function thermalEdge(heat: number): string {
  const c = thermalColor(heat);
  return `linear-gradient(to bottom, ${c}, color-mix(in oklab, ${c} 55%, transparent))`;
}
